import '../../styles/sections/dynamic-cart.scss';

import { changeCart } from '../utils/cart';

class DynamicCart extends HTMLElement {
  constructor() {
    super();

    this.closeButton = this.querySelector('[data-close-dynamic-cart]');
    
    this.wrapper = this.querySelector('[data-dynamic-cart-wrapper]');
    this.itemsList = this.querySelector('[data-items-list]');
    this.cartFooter = this.querySelector('[data-cart-footer]');
    this.form = this.querySelector('form')

    this.closeButton.addEventListener('click', this.closeCart.bind(this));

    window.addEventListener('dynamic-cart-loading', this.loading.bind(this));
    window.addEventListener('dynamic-cart-open', this.openCart.bind(this));
    window.addEventListener('ajax-cart', this.updateCart.bind(this));

    this.addEventListener('click', this.closeCart.bind(this));
    this.wrapper.addEventListener('click', (event) => {event.stopPropagation()});

    this.initItemsInteractions();
  }

  initItemsInteractions() {
    this.quantityInputs = Array.from(this.querySelectorAll('[data-input-item-key]'));
    this.removeButtons = Array.from(this.querySelectorAll('[data-remove-item]'));
    
    this.quantityChangeFunction = this.quantityChange.bind(this);

    this.quantityInputs.forEach(input => {
      input.addEventListener('change', this.quantityChangeFunction);
    });

    this.removeButtons.forEach(button => {
      button.addEventListener('click', this.removeItem);
    });
  }

  closeCart(event) {
    event.preventDefault();
    this.removeAttribute('opened');
    this.setAttribute('closed', '');
  }

  openCart() {
    this.setAttribute('opened', '');
    this.removeAttribute('closed');
  }

  loading() {
    this.form.classList.add('loading-state', "loading");
  }

  quantityChange(event) {
    const currentQuantityInput = event.currentTarget;

    changeCart(currentQuantityInput.dataset.inputItemKey, currentQuantityInput.value);
  }

  removeItem(event) {
    event.preventDefault();

    const currentQuantityInput = event.currentTarget;

    changeCart(currentQuantityInput.dataset.removeItem, 0);
  }

  updateCart(event) {
    const sectionHTML = event.detail.cartSections['dynamic-cart'];
    
    const tempElement = document.createElement('div');
    tempElement.innerHTML = sectionHTML.replaceAll('dynamic-cart>', 'div>'); //replace is important otherwise the constructor is called again because of the element inside the tempElement and adds duplicated events

    const updatedCartItemsHTML = tempElement.querySelector('[data-items-list]').innerHTML;
    const cartFooterHTML = tempElement.querySelector('[data-cart-footer]').innerHTML;

    this.itemsList.innerHTML = updatedCartItemsHTML;
    this.cartFooter.innerHTML = cartFooterHTML;

    this.form.classList.remove('loading-state', "loading");

    this.initItemsInteractions();
  }
}

customElements.define('dynamic-cart', DynamicCart)